import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { hasModuleAccess } from '../../services/accessService';
import { selectAppModulesAccess } from '../../state/selectors/app';

const ModuleAccess = (props) => {
    const {access, moduleName, children, onClick} = props;
    const appModulesAccess = useSelector(selectAppModulesAccess());
    const [isAccess, setIsAccess] = useState(false);

    useEffect(() => {
        const isAcc = hasModuleAccess(moduleName, access);
        setIsAccess(isAcc);
    }, [appModulesAccess]);

    return (isAccess ? children : <></>);
}

export default ModuleAccess;